import { createComponentHealth } from '@shared/components/ComponentHealth';

export const [wrapWithGuestSiteFeatureSetHealthProvider, useGuestSiteFeatureSetHealth] = createComponentHealth('GuestSiteFeatureSet');
